import React from 'react';
import PropTypes from 'prop-types';

import { SpinnerLoader } from './Loading.styled';

const Spinner = ({ width, color, style }) => (
  <SpinnerLoader width={width || '60px'} color={color} style={style}>
    <svg className="circular" viewBox="25 25 50 50">
      <circle
        className="path"
        cx="50"
        cy="50"
        r="20"
        fill="none"
        strokeWidth="2"
        strokeMiterlimit="10"
      />
    </svg>
  </SpinnerLoader>
);

Spinner.propTypes = {
  width: PropTypes.string,
  style: PropTypes.object,
  color: PropTypes.string,
};

export default Spinner;
